import React, { Component } from 'react'
import { Table, Spin } from 'antd'

class OverviewByUser extends Component {
  getColumns = () => {
    return [
      {
        title: '',
        children: [
          {
            title: 'User',
            dataIndex: 'user'
          }
        ]
      },
      {
        title: 'Total Added During Time Period',
        children: [
          {
            title: 'Contacts',
            dataIndex: 'contacts'
          },
          {
            title: 'Companies',
            dataIndex: 'companies'
          },
          {
            title: 'Leads',
            dataIndex: 'leads'
          },
          {
            title: 'Estimates',
            dataIndex: 'estimates'
          },
          {
            title: 'Proposals',
            dataIndex: 'proposals'
          },
          {
            title: 'Contracts',
            dataIndex: 'contracts'
          }
        ]
      }
    ]
  }

  getData = () => {
    const { overviewByUserData } = this.props

    const data = overviewByUserData.map(user => {
      const returnObj = Object.assign({ key: user.id }, user)
      delete returnObj.id
      return returnObj
    })
    return data
  }

  render() {
    const { loadingOverviewByUser, overviewByUserData } = this.props
    return (
      <div>
        {loadingOverviewByUser && !overviewByUserData && <Spin />}
        {!loadingOverviewByUser &&
          overviewByUserData && (
            <Table
              pagination={false}
              columns={this.getColumns()}
              dataSource={this.getData()}
              size="small"
              style={{ backgroundColor: 'white' }}
            />
          )}
      </div>
    )
  }
}

export default OverviewByUser



// WEBPACK FOOTER //
// ./src/components/reports/general/activity-report/OverviewByUser.js